import { createCustomIcon } from './utils/createCustomIcon';

const FilledCircleIcon = createCustomIcon({
  displayName: 'FilledCircleIcon',
  defaultFill: 'currentColor',
  children: <circle cx="12" cy="12" r="10" />,
});

export default FilledCircleIcon;
